import React, { useState, useCallback, memo } from "react";
import { useNavigate } from "react-router-dom";

const LeaveSummarySection = memo(
  ({ leaveData = [], leaveOpen, toggleLeaveOpen }) => {
    const navigate = useNavigate();
    const navigateToCompOff = useCallback(() => {
      navigate("/apply-comp-off");
    }, [navigate]);

    const navigateToLeave = useCallback(() => {
      navigate("/apply-leave");
    }, [navigate]);

    return (
      <div className="row mt-2">
        <div className="col-md-12 dashKPI">
          <div className="custom-accordion">
            <div className="custom-header" onClick={toggleLeaveOpen}>
              <div className="d-flex justify-content-between">
                <div className="leader_Board-card">
                  <h5>Leave Summary</h5>
                </div>
              </div>
              <span className={`arrow-icon ${leaveOpen ? "open" : ""}`}>
                <i className="bi bi-arrow-down-circle-fill"></i>
              </span>
            </div>
            {leaveOpen && (
              <div className="leave-custom-body">
                <div className="container">
                  <div className="row">
                    <div className="col-md-9 p-0">
                      <table className="dashleaveSummary-table">
                        <thead>
                          <tr>
                            <th>Leave</th>
                            <th>Accrued</th>
                            <th>Applied</th>
                            <th>Approved</th>
                            <th>Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {leaveData?.map((leave, index) => (
                            <tr key={index}>
                              <td>{leave.LeaveType || ""}</td>
                              <td>{leave.LeaveAccrued || ""}</td>
                              <td>{leave.LeaveApplied || ""}</td>
                              <td>{leave.LeaveApproved || ""}</td>
                              <td>{leave.LeaveBalance || ""}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="col-md-3 p-0">
                      <div className="leave-summary-section">
                        <div
                          className="leave-summary-content"
                          onClick={navigateToLeave}
                        >
                          <div className="leave-summary-icon">
                            <i className="bi-file-earmark-text"></i>
                          </div>
                          <h6>Leave Application</h6>
                        </div>
                        <div
                          className="leave-summary-content"
                          onClick={navigateToCompOff}
                        >
                          <div className="leave-summary-icon">
                            <i className="bi-file-earmark-text"></i>
                          </div>
                          <h6>Comp Off Application</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
);

export default LeaveSummarySection;
